import PopupGridButton from '../PopupGridButton/PopupGridButton';
import { useContext, useEffect } from 'react';
import ContextMenuContext from '../../kingpin/atoms/ContextMenu/ContextMenuContext';
import DashboardContext from '../../contexts/DashboardContext';
import usePopup from '../../hooks/usePopup';
import BaseViewsContext from '../../contexts/BaseViewsContext';
import AnalyticsContext from '../../contexts/AnalyticsContext';

const PopupGridButtonContainer = ({
  chartDefinition,
}: {
  chartDefinition: VisualisationDefinitions.GroupVsRemainder;
}) => {
  const { hideMenu } = useContext(ContextMenuContext);
  const { setIsPopupGridOpen } = useContext(DashboardContext);
  const {
    isOpen: isGridOpen,
    open: openGrid,
    close: closeGrid,
  } = usePopup(false, undefined, true);
  const { isLoading } = useContext(BaseViewsContext);
  const { trackEvent } = useContext(AnalyticsContext);

  const onGridOpened = () => {
    hideMenu();
    openGrid();
  };

  useEffect(() => {
    if (isGridOpen) {
      trackEvent('Card - Popup Grid Opened');
    }
  }, [isGridOpen, trackEvent]);

  useEffect(() => {
    setIsPopupGridOpen(isGridOpen);
  }, [isGridOpen, setIsPopupGridOpen]);

  return (
    <PopupGridButton
      isGridOpen={isGridOpen}
      openGrid={onGridOpened}
      closeGrid={closeGrid}
      isLoadingGridDefinitions={isLoading}
      dataType={chartDefinition.dataset}
    />
  );
};

export default PopupGridButtonContainer;
